import { z } from 'zod';
/**
 * Paginación por cursor: `?limit=20&cursor=…` → `{ data: [...], nextCursor: string|null }`.
 * `limit` máx. 100. El cursor es opaco para el cliente (base64url de JSON).
 */
export const DEFAULT_PAGE_LIMIT = 20;
export const MAX_PAGE_LIMIT = 100;
export const PaginationQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_LIMIT).default(DEFAULT_PAGE_LIMIT),
    cursor: z.string().min(1).max(512).optional(),
});
/** Rango de fechas común en listados (`from`, `to` ISO 8601). */
export const DateRangeQuerySchema = z.object({
    from: z.iso.datetime({ offset: true }).optional(),
    to: z.iso.datetime({ offset: true }).optional(),
});
export function paginatedSchema(item) {
    return z.object({
        data: z.array(item),
        nextCursor: z.string().nullable(),
    });
}
/** Codifica una posición (p. ej. `{ createdAt, id }`) como cursor opaco. */
export function encodeCursor(position) {
    return toBase64Url(JSON.stringify(position));
}
export function decodeCursor(cursor) {
    try {
        const parsed = JSON.parse(fromBase64Url(cursor));
        if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed))
            throw new Error('shape');
        return parsed;
    }
    catch {
        throw new TypeError('Cursor inválido');
    }
}
// base64url portable (Node 22 y navegador; sin Buffer).
function toBase64Url(text) {
    const bytes = new TextEncoder().encode(text);
    let binary = '';
    for (const byte of bytes)
        binary += String.fromCharCode(byte);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function fromBase64Url(value) {
    const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
    const binary = atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '='));
    return new TextDecoder().decode(Uint8Array.from(binary, (c) => c.charCodeAt(0)));
}
//# sourceMappingURL=pagination.js.map